//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowCode(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17.27 6H14.66L19.66 12L14.66 18H17.27L22.27 12L17.27 6ZM6.72998 6L1.72998 12L6.72998 18H9.34003L4.34003 12L9.34003 6H6.72998Z" fill="currentColor" /></svg>;
}
export default IconArrowCode;